require('datatables.net-bs4');

$(document).ready(function() {
  if($('[id^=questions_datatable_wrapper]').length == 0 && $('#questions_datatable').length > 0) {
    table = $('#questions_datatable').DataTable({
      dom: "<'row'<'col-6'l><'#question_btn_add.col-6 text-right'>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'float-right mb-3'p>",
      pagingType: 'full_numbers',
      lengthMenu: [[10, 20, 50], ["10件", "20件", "50件"]],
      language: {
        lengthMenu: "_MENU_ を表示する",
        paginate: {
          first: '<< 最初へ',
          last: '最後へ >>',
          next: '次へ >',
          previous: '< 前へ',
        },
        emptyTable: "よくある質問は登録されておりません",
      },
      order: [],
      ordering: false,
      columnDefs: [
        {
          targets: 0,
          orderable: false,
          width: "10%",
        },
        {
          targets: 2,
          width: "15%",
        },
        {
          targets: 3,
          orderable: false,
          width: "10%",
        },
        {
          targets: 4,
          orderable: false,
          visible: false
        },
      ],
      drawCallback: function() {
        $('.dataTables_empty').text('よくある質問は登録されておりません');
        var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
        pagination.toggle(this.api().page.info().pages > 1);
        if($('.checkbox_question').length == 0) {
          $('#question_checkbox_check_all').prop('checked', false);
        }
        else {
          number_of_checkbox_unchecked = $('.checkbox_question:checkbox:not(:checked)').not(':disabled').length;
          if (number_of_checkbox_unchecked > 0) {
            $('#question_checkbox_check_all').prop('checked', false);
          } else {
            $('#question_checkbox_check_all').prop('checked', true);
          }
        }
      },
      stateSave: true
    });

    $('#questions_datatable_length').before('<label class="mr-2">' +
      '<select id="question_select_display_flag" class="custom-select custom-select-sm form-control form-control-sm">' +
        '<option value="">-- 表示・非表示 --</option>' +
        '<option value="show">表示</option>' +
        '<option value="hidden">非表示</option>' +
      '</select>' +
    '</label>');
    selectQuestionCategoryElement($('.show-data').data("category-options"));
    if (!/iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent)) {
      $('#select_category').select2({
        width: 'element',
        minimumResultsForSearch: -1
      });
    }
    $('#question_btn_add').append('')
    $('#question_btn_add').append(`<a href='${$('.show-data').data("add-new-link")}' class='btn btn-info'>新規追加</a>`);

    setTimeout(function() {
      search = table.state().columns[4].search.search
      $('#question_select_display_flag').val(search);
    }, 450);
    $('#question_select_display_flag').on( 'change', function () {
      table.columns(4).search(this.value).draw();
    } );

    $('body').on('click', '#question_checkbox_check_all', function() {
      if (this.checked) {
        $('.checkbox_question').not(':disabled').prop('checked', true);
      } else {
        $('.checkbox_question').not(':disabled').prop('checked', false);
      }
    });

    $('#select_category').on('change', function(){
      const val = $.fn.dataTable.util.escapeRegex(
        $(this).val()
      );
      table.column(2).search(val ? '^'+val+'$' : '', true, false).draw();
    })

    $('body').on('click', '.checkbox_question', function() {
      number_of_checkbox_unchecked = $('.checkbox_question:checkbox:not(:checked)').not(':disabled').length;
      if (number_of_checkbox_unchecked > 0) {
        $('#question_checkbox_check_all').prop('checked', false);
      } else {
        $('#question_checkbox_check_all').prop('checked', true);
      }
    });

    $('body').on('click', '#question_batch_delete_question_btn', function(event) {
      if ($('.checkbox_question:checked').not(':disabled').length == 0) {
        event.preventDefault();
        alert('チェックボックスが選択されていません');
        return false;
      }
    });
  }
});

function selectQuestionCategoryElement(menuCategories) {
  var $labelElm = $("<label>", {class: "mr-2"});
  var $selectElm = $("<select>", {class: "custom-select custom-select-sm form-control form-control-sm", id: "select_category"});
  var $option = $("<option>", {text: "カテゴリー一覧", value: ""});
  $selectElm.append($option);
  $.each(menuCategories, function( index, value ) {
    var $option = $("<option>", {text: value["name"], value: value["id"]});
    $selectElm.append($option);
  });
  // $selectElm.on('change', filterMenuByCategory);
  $labelElm.append($selectElm);
  $("#question_select_display_flag").parent().before($labelElm);
}
